import api from "@/plugins/api";
const PATH = "/opcat-catalogs";
const PAGE_SIZE = 100;
export function toValueList(wire) {
    return {
        code: wire.code,
        names: { fr: wire.nameFr, en: wire.nameEn, nl: wire.nameNl },
        isHierarchical: wire.isHierarchical,
    };
}
async function fetchPage(page) {
    const response = await api.get(PATH, {
        params: { page, pageSize: PAGE_SIZE },
    });
    return response.data;
}
/**
 * Reads every page: the tabs, their counts and the pager all work on the whole set in the browser,
 * so stopping at the first page would silently drop lists from all three.
 */
export async function fetchValueLists() {
    const first = await fetchPage(1);
    const totalPages = first.pagination?.totalPages ?? 1;
    const rest = await Promise.all(Array.from({ length: Math.max(0, totalPages - 1) }, (_, index) => fetchPage(index + 2)));
    return [first, ...rest].flatMap((page) => (page.data ?? []).map(toValueList));
}
